export default "__VITE_ASSET__DnyiYoZe__"